import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const ReturnPolicy: React.FC = () => {
  return (
    <PolicyLayout title="Return Policy" image="/images/fhome-honey-pour.jpg">
      <p>
        We have a 3-day return policy from the date of purchase, subject to eligibility.
      </p>

      <h3>Eligibility</h3>
      <ul>
        <li>Item must be unused and in original condition.</li>
        <li>Item must include original packaging.</li>
        <li>Certain sale or exempted categories may not be eligible.</li>
      </ul>

      <h3>Quality Check</h3>
      <p>
        Approved return or exchange requests are processed after inspection and quality verification.
      </p>

      <h3>Exchange and Replacement Timeline</h3>
      <p>
        Exchange and replacement products will be delivered within 7 days after approval.
      </p>
    </PolicyLayout>
  );
};

export default ReturnPolicy;
